module.exports = __webpack_public_path__ + "static/media/copy.77397ca1.svg";